"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VSMART = [
    { deviceName: 'Vsmart Active 1+', brandName: 'Vsmart', deviceCode: 'Active 1+' },
    { deviceName: 'Vsmart Active 1', brandName: 'Vsmart', deviceCode: 'Active 1' },
    { deviceName: 'Vsmart Live', brandName: 'Vsmart', deviceCode: 'Live' },
    { deviceName: 'Vsmart Joy 1+', brandName: 'Vsmart', deviceCode: 'Joy 1+' },
    { deviceName: 'Vsmart Joy 1', brandName: 'Vsmart', deviceCode: 'Joy 1' }
];
//# sourceMappingURL=vsmart.js.map